import { createIcon } from "@chakra-ui/react";

export const Tick = createIcon({
  displayName: "Tick",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.868-14.88a.876.876 0 0 0 0-1.238h.003a.876.876 0 0 0-1.239 0l-6.382 6.38-2.882-2.88a.876.876 0 0 0-1.239 1.239l3.5 3.5a.876.876 0 0 0 1.24 0l7-7z"
    />,
  ],
  defaultProps: {
    "aria-label": "A tick within a circle"
  }
});

export default Tick;
